"use client";

import { Suspense } from "react";
import { NativeWidgetStatsPublisher } from "@/components/providers/native-widget-stats-publisher.client";
import { useActiveChatBridge } from "@/hooks/use-active-chat-bridge";
import { useDeepLinkHandler } from "@/hooks/use-deep-link-handler";
import { useForegroundPush } from "@/hooks/use-foreground-push";
import { useNativeSessionOwner } from "@/hooks/use-native-session-owner";

/**
 * Provider that sets up deep link handling for the app.
 * Handles:
 * - Live Activity taps (Dynamic Island / Lock Screen)
 * - Notification taps with deep link URLs
 */
function DeepLinkEffects() {
  useNativeSessionOwner();
  useDeepLinkHandler();
  useForegroundPush();
  useActiveChatBridge();
  return null;
}

export function DeepLinkProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <Suspense fallback={<span hidden aria-hidden="true" />}>
        <DeepLinkEffects />
      </Suspense>
      <NativeWidgetStatsPublisher />
    </>
  );
}
